console.clear = function(){return true;}
